<script setup lang="ts">
import { RouteName } from "@/router";
import { mdiPhone } from "@mdi/js";
import { computed } from "vue";
import { useRoute } from "vue-router";

const activeRoute = useRoute();

const isHidden = computed(() =>
  [RouteName.ErrorReportsCreate].includes(activeRoute.name as RouteName),
);
</script>

<template>
  <footer v-if="!isHidden" class="footer mt-6">
    <section class="container section pa-0">
      <div class="columns is-centered is-vcentered">
        <div class="column is-4">
          <p class="title is-6 has-text-white-bis">Om ONE Nordic</p>
          <p class="has-text-white-bis">
            ONE Nordic koncernen är Nordens ledande leverantör inom
            energitekniska tjänster, service och entreprenad. Vi är en
            rikstäckande koncern med ca 1200 anställda. Våra etableringar är
            spridda på ett 40-tal orter med huvudkontor i Malmö.
          </p>
        </div>

        <div class="column is-1"></div>

        <div class="column is-3">
          <div class="box is-shadowless has-text-centered">
            <a
              class="title is-5 mb-2 is-flex is-justify-content-center"
              href="tel:+46771330033"
            >
              <span class="icon-text">
                <span class="icon is-medium">
                  <app-icon :icon="mdiPhone" size="24" />
                </span>
                <span>0771-330033</span>
              </span>
            </a>

            <p>Växelnummer</p>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>
